<section class="shopflow" [class.shopflow--collapsible]="collapsibleMobile" [class.shopflow--open]="open()"
  aria-label="Ablauf von der Bestellung bis zur Lieferung">
  <header class="shopflow__head" [attr.role]="collapsibleMobile && isMobile() ? 'button' : null"
    [attr.tabindex]="collapsibleMobile && isMobile() ? 0 : null"
    [attr.aria-expanded]="collapsibleMobile && isMobile() ? open() : null"
    (click)="toggle()" (keydown.enter)="toggle()">
    <span class="shopflow__eyebrow">{{ eyebrow }}</span>
    <h2 class="shopflow__title" [innerHTML]="title"></h2>
    @if (collapsibleMobile) {
    <ng-icon class="shopflow__chev" name="bootstrapChevronDown" aria-hidden="true"></ng-icon>
    }
    <p class="shopflow__lead">{{ lead }}</p>
  </header>
  <ol class="shopflow__steps">
    @for (step of steps; track step.title; let i = $index) {
    <li class="shopflow__step" [class.shopflow__step--current]="i === current"
      [attr.aria-current]="i === current ? 'step' : null">
      @if (i === current) { <span class="shopflow__here" i18n="@@shopFlow.here">Du bist hier</span> }
      <div class="shopflow__ico"><ng-icon [name]="step.icon"></ng-icon><span class="shopflow__num">{{ i + 1 }}</span></div>
      <h3 class="shopflow__step-title">{{ step.title }}</h3>
      <p class="shopflow__step-text">{{ step.text }}</p>
    </li>
    }
  </ol>
  @if (outro) { <p class="shopflow__outro">{{ outro }}</p> }

  @if (productionVideoId) {
  <div class="shopflow__production">
    <div class="shopflow__prod-head">
      <h3 class="shopflow__prod-title">{{ productionTitle }}</h3>
      <p class="shopflow__prod-text">{{ productionText }}</p>
    </div>
    <div class="shopflow__video">
      @if (!videoOpen) {
      <button type="button" class="shopflow__video-btn" (click)="openVideo()"
        [attr.aria-label]="'Produktionsvideo abspielen: ' + productionTitle">
        <img class="shopflow__poster" [src]="posterUrl" (error)="onPosterError($event)" alt="" loading="lazy" />
        <span class="shopflow__play"><ng-icon name="bootstrapPlayFill" aria-hidden="true"></ng-icon></span>
      </button>
      } @else {
      <iframe class="shopflow__iframe" [src]="embedUrl" [title]="productionTitle"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen loading="lazy"></iframe>
      }
    </div>
  </div>
  }
</section>
